import React from 'react';
import { Youtube, FileText, Mic, Presentation, ArrowRight, Settings, FileCheck } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function HowItWorksSlide(props: SlideProps) {
  return <SlideLayout {...props} title="How It Works" subtitle="A seamless workflow from raw content to final exam paper." data-id="element-38">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-16 relative" data-id="element-39">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-slate-100 -z-10 -translate-y-1/2" data-id="element-40"></div>

        {/* Step 1: Input */}
        <div className="flex flex-col items-center text-center bg-white p-6 rounded-2xl border border-slate-100 shadow-sm w-full md:w-1/3 z-10" data-id="element-41">
          <div className="flex gap-2 mb-6" data-id="element-42">
            <div className="p-3 bg-red-100 text-red-600 rounded-lg" data-id="element-43">
              <Youtube className="w-6 h-6" data-id="element-44" />
            </div>
            <div className="p-3 bg-blue-100 text-blue-600 rounded-lg" data-id="element-45">
              <FileText className="w-6 h-6" data-id="element-46" />
            </div>
            <div className="p-3 bg-orange-100 text-orange-600 rounded-lg" data-id="element-47">
              <Presentation className="w-6 h-6" data-id="element-48" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-49">
            1. Upload Content
          </h3>
          <p className="text-slate-500 text-sm" data-id="element-50">
            Paste a YouTube URL, upload a PDF, PPT, or audio recording.
          </p>
        </div>

        <ArrowRight className="w-8 h-8 text-slate-300 rotate-90 md:rotate-0 flex-shrink-0" data-id="element-51" />

        {/* Step 2: Process */}
        <div className="flex flex-col items-center text-center bg-indigo-600 p-6 rounded-2xl shadow-xl shadow-indigo-200 w-full md:w-1/3 z-10 transform scale-110" data-id="element-52">
          <div className="mb-6 relative" data-id="element-53">
            <div className="absolute inset-0 bg-white/20 blur-xl rounded-full animate-pulse" data-id="element-54"></div>
            <div className="p-4 bg-white/10 text-white rounded-xl relative border border-white/20" data-id="element-55">
              <Settings className="w-8 h-8 animate-spin-slow" data-id="element-56" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-57">
            2. AI Generation
          </h3>
          <p className="text-indigo-100 text-sm" data-id="element-58">
            EduAssess analyzes content, extracts key concepts, and generates
            questions.
          </p>
        </div>

        <ArrowRight className="w-8 h-8 text-slate-300 rotate-90 md:rotate-0 flex-shrink-0" data-id="element-59" />

        {/* Step 3: Output */}
        <div className="flex flex-col items-center text-center bg-white p-6 rounded-2xl border border-slate-100 shadow-sm w-full md:w-1/3 z-10" data-id="element-60">
          <div className="mb-6" data-id="element-61">
            <div className="p-4 bg-emerald-100 text-emerald-600 rounded-xl" data-id="element-62">
              <FileCheck className="w-8 h-8" data-id="element-63" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-64">
            3. Export & Print
          </h3>
          <p className="text-slate-500 text-sm" data-id="element-65">
            Review, make quick edits, and download the perfectly formatted PDF.
          </p>
        </div>
      </div>
    </SlideLayout>;
}